import { BehaviorSubject } from 'rxjs';

export const _defaultTitleBase = 'Virgin Money';

export const _pageTitleInitialValue: {
  title: string[];
} = {
  title: [],
};

const subject = new BehaviorSubject(_pageTitleInitialValue);

const update = (title: string | string[]): void => {
  if (!Array.isArray(title)) {
    title = [title];
  }
  subject.next({ title: [...title] });
};

const getPageTitle = () => {
  const { title } = subject.value;
  if (title && title.length) {
    return [_defaultTitleBase, ...title].join(' | ');
  }
  return _defaultTitleBase;
};

export const pageTitle = { update, getPageTitle, subject };
